module.exports = __webpack_public_path__ + "img/cz.7b52db17.jpg";